// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1g97Z","itemTitle":"ClientEmergencyInfo_itemTitle__Ow-iK","itemText":"ClientEmergencyInfo_itemText__1E_EH"};